export default "__VITE_ASSET__D9eBS1Jx__"